import type { BadgeProps } from '@libs/ui/ds'
import { Badge } from '@libs/ui/ds'
import React, { forwardRef, useMemo } from 'react'

type Props = {
  count: number
  label?: BadgeProps['label']
  'data-testid'?: BadgeProps['data-testid']
}

const BadgeCounter = forwardRef<HTMLDivElement, Props>(
  ({ count, label, ...other }, ref) => {
    const color = useMemo((): BadgeProps['color'] => {
      const roundedCount = Math.round(count * 60)

      if (roundedCount > 0) {
        return 'semantic.red'
      }
      if (roundedCount < 0) {
        return 'semantic.orange'
      }
      if (roundedCount === 0) {
        return 'semantic.green'
      }
    }, [count])

    return (
      <Badge
        ref={ref}
        variant='light'
        size='s'
        color={color}
        label={label}
        {...other}
      />
    )
  }
)

export default BadgeCounter
